import {
  DeliveryColumnTypes,
  DeliveryLineWithDelivery,
} from 'src/app/delivery-data/delivery-data.model';
import { CustomerBrsNumber } from 'src/app/shared/models/shared.models';

import { DateRange } from '../../../shared/models/date-range.model';

export const displayColumns = [
  DeliveryColumnTypes.deliveryDate,
  DeliveryColumnTypes.allShipToIds,
  DeliveryColumnTypes.externalProductId,
  DeliveryColumnTypes.productTitle,
  DeliveryColumnTypes.klwArticleGroupName,
  DeliveryColumnTypes.unitQuantity,
  DeliveryColumnTypes.vem,
  DeliveryColumnTypes.roughProtein,
  DeliveryColumnTypes.nitrogen,
  DeliveryColumnTypes.phosphorus,
  DeliveryColumnTypes.dryMatterAmount,
  DeliveryColumnTypes.roughAshes,
] as const;

export type BexOverviewViewModel = Pick<
  DeliveryLineWithDelivery,
  (typeof displayColumns)[number] | 'id' | 'deliveryId'
>;

export interface BexOverviewDataFilters {
  brsNumber: CustomerBrsNumber;
  search: string;
  dateRange: DateRange;
}
